export function MenuTag({ text, color }: { text: string; color: string }) {
  return (
    <div
      className={`inline-block px-1 text-xs font-medium rounded ${color} text-white`}
    >
      {text}
    </div>
  );
}
